import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { Form, Input, FormGroup, Label, Button } from 'reactstrap';
import { toast } from 'react-toastify';

import TextFieldGroup from '../../Common/TextFieldGroup';
import ProgressIndicator from '../../Common/ProgressIndicator';
import Axios from 'axios';

function ProfileForm(props) {
    const [profile, setProfile] = useState({
        alias: '',
        godparent1Id: '',
        godparent2Id: ''
    });
    const [isSaving, setIsSaving] = useState(false);

    useEffect(() => {
        setProfile({
            alias: props.profile.alias,
            godparent1Id: props.profile.godparent1Id,
            godparent2Id: props.profile.godparent2Id
        });
    }, [props]);

    function handleChange(e) {
        e.persist();
        setProfile((prevState) => {
            return { ...prevState, [e.target.name]: e.target.value }
        });
    }

    function handleSubmit(e) {
        e.preventDefault();
        setIsSaving(true);
        Axios.post('/profile', { ...profile }).then(res => {
            setIsSaving(false);
            toast.success("Profil frissítve.");
        }, err => {
            toast.error("A profil frissítése sikertelen.");
        });
    }

    const firmaOptions = props.members.map((item) => 
        <option value={item.id} key={item.id}>{item.alias ? item.name + " alias " + item.alias : item.name}</option>
    );

    if (isSaving)
        return <ProgressIndicator />;

    return (
        <Form onSubmit={handleSubmit}>
            <div className="col-md-8 mx-auto">
                <TextFieldGroup
                    field="alias"
                    onChange={handleChange}
                    label="Alias"
                    value={profile.alias} />

                <FormGroup>
                    <Label for="godparents">Keresztszülők</Label>
                    <Input
                        type="select"
                        name="godparent1Id"
                        value={profile.godparent1Id}
                        onChange={handleChange}
                        invalid={false}>
                        <option value="">-</option>
                        {firmaOptions}
                    </Input>
                    <Input
                        type="select"
                        name="godparent2Id"
                        value={profile.godparent2Id}
                        onChange={handleChange}
                        invalid={false}>
                        <option value="">-</option>
                        {firmaOptions}
                    </Input>
                </FormGroup>
            </div>
            <FormGroup>
                <Button color="primary"><FontAwesomeIcon icon={faCheck} /> Mentés</Button>
            </FormGroup>
        </Form>
    );
}

export default ProfileForm;
